import React from 'react';

export const Labels: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
      }}
    >
      {/* Probability Table */}
      <div style={{ marginBottom: '10px' }}>
        <h1
          style={{
            textAlign: 'left',
            marginBottom: '10px',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          Probabilidade
        </h1>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #ddd',
            marginBottom: '20px',
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#E0F4E9',
                  width: '20%',
                }}
              >
                Probabilidade
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'left',
                  backgroundColor: '#E0F4E9',
                  width: '80%',
                }}
              >
                Saúde e Segurança (SS)
              </th>
            </tr>
          </thead>
          <tbody>
            {probabilityData.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'center',
                  }}
                >
                  {item.value}
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    fontSize: '10px',
                  }}
                >
                  <>
                    <div
                      style={{
                        width: '100%',
                        flex: 1,
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      {item.type}
                    </div>
                    {item.descriptions.map((part, i) => (
                      <React.Fragment key={i}>
                        {part} <br />
                      </React.Fragment>
                    ))}
                  </>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Severity Table */}
      <div style={{ breakInside: 'avoid' }}>
        <h2
          style={{
            textAlign: 'left',
            marginBottom: '10px',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          Severidade
        </h2>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #ddd',
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#E0F4E9',
                  width: '20%',
                }}
              >
                Severidade
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'left',
                  backgroundColor: '#E0F4E9',
                  width: '80%',
                }}
              >
                Tipo de Lesão Provável
              </th>
            </tr>
          </thead>
          <tbody>
            {severityData.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'center',
                  }}
                >
                  {item.value}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {item.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Probability data
const probabilityData = [
  {
    value: '0.033',
    type: 'Quase impossível',
    descriptions: [
      '1 - Ocorreu dano em período superior a 10 anos.',
      '2 - Perigo enclausulado + Colaborador Treinado + Colaborador ciente dos riscos.',
    ],
  },
  {
    value: '1',
    type: 'Altamente improvável',
    descriptions: [
      '1 - Ocorreu dano em período entre 5 e 10 anos.',
      '2 - Perigo enclausulado + Colaborador Treinado + Colaborador com dúvida nos riscos.',
    ],
  },
  {
    value: '1,5',
    type: 'Improvável',
    descriptions: [
      '1 - Ocorreu dano em período entre 2 e 5 anos',
      '2 - Perigo com barreira + Colaborador Treinado + Colaborador com dúvida nos riscos.',
    ],
  },
  {
    value: '2',
    type: 'Possível',
    descriptions: [
      '1 - Ocorreu dano em período entre 1 a 2 anos',
      '2 - Perigo com barreira + Colaborador não segue totalmente o procedimento + Colaborador com dúvida nos riscos.',
    ],
  },
  {
    value: '5',
    type: 'Alguma chance',
    descriptions: [
      '1 - Ocorreu dano em período entre 6 meses a 1 ano',
      '2 - Perigo com barreira + Colaborador não segue totalmente o procedimento + Colaborador não conhece os riscos.',
    ],
  },
  {
    value: '8',
    type: 'Provável',
    descriptions: [
      '1 - Ocorreu dano em período entre 1 mês a 6 meses',
      '2 - Perigo com barreira danificada + Colaborador não segue totalmente o procedimento + Colaborador não conhece os riscos.',
    ],
  },
  {
    value: '10',
    type: 'Muito Provável',
    descriptions: [
      '1 - Ocorreu dano em período entre 1 semana e 1 mês.',
      '2 - Perigo com barreira danificada + Colaborador não treinado + Colaborador não conhece os riscos.',
    ],
  },
];

// Severity data
const severityData = [
  {
    value: '0,1',
    description: 'Arremão / Escolação / Contusão leve/picada de insetos.',
  },
  {
    value: '0,5',
    description:
      'Dilaceração / Corte / Queimadura de 1º Grau em mãos, braços e pernas.',
  },
  {
    value: '1',
    description:
      'Fratura Leve Ossos/ Queimadura de 2º Grau mãos, braços e pernas.',
  },
  {
    value: '2',
    description:
      'Fratura Grave/ Queimadura de 3º Grau mãos, braços e pernas/Reações alérgicas severas.',
  },
  {
    value: '4',
    description:
      'Perta de 1 ou 2 dedos da Mão ou do Pé/ Queimadura de 2º e/ou 3º Grau em 50% do corpo.',
  },
  {
    value: '8',
    description:
      'Amputação de Perna, braços e/ou mão/ Queimadura de 2º e/ou 3º Grau em 70% do corpo.',
  },
  {
    value: '10',
    description:
      'Amputação de ambas as pernas, braços e/ou mãos / Queimadura de 2º e/ou 3º em 80% do corpo.',
  },
  {
    value: '12',
    description:
      'Enfermidade permanente ou crítica / Picada de Cobra/ Afogamento/ Queimadura de 2º e/ou 3º Grau em mais de 90% do corpo.',
  },
  { value: '15', description: 'Morte.' },
];
